function Contact() {
  return (
    <>
      <section class="l-contain l-section l-section--separated">
        <form
          action="https://formsubmit.co/alajogunayomide@gmail.com"
          method="POST"
          class="form text-left">
          <h6 class="formTitle" style={{ color: "#FFFFFF" }}>
            Want to keep in touch?
          </h6>
          <p class="formDescription" style={{ color: "#FFFFFF" }}>
            I will respond promptly
          </p>
          <input
            id="name"
            type="text"
            name="name"
            placeholder="Name"
            class="formInput about"
            style={{ color: "var(--color-text-headings)" }}
            required
          />
          <input
            id="email"
            type="email"
            name="email"
            placeholder="Email"
            class="formInput about"
            style={{ color: "var(--color-text-headings)" }}
            required
          />
          <textarea
            id="message"
            name="message"
            cols="30"
            rows="4"
            placeholder="Message"
            class="formInput about"
            required
            style={{ color: "var(--color-text-headings)" }}></textarea>
          <div className="w-100">
            <button
              class="text-center w-100 text-decoration-none d-flex align-items-center justify-content-center formButton about"
              style={{ color: "#FFFFFF" }}>
              Reach Out
            </button>
          </div>
        </form>
      </section>
    </>
  );
}
export default Contact;
